import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";
import { COMPETITORS } from "@/data/comparisons";
import PlanFinder from "@/components/PlanFinder";

export default function CompareHub() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/compare").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen">
      <SiteHeader />
      <section className="paper-noise border-b border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
          <div className="font-mono-label text-muted-foreground mb-4">The DocuMind Review · Comparisons</div>
          <h1 className="font-serif-display text-5xl lg:text-7xl tracking-tighter max-w-4xl leading-[0.95]">
            How DocuMind stacks up <span className="italic">against every</span> chat-with-PDF tool worth comparing.
          </h1>
          <p className="mt-8 text-lg text-muted-foreground max-w-2xl">
            Honest, feature-by-feature breakdowns written by the DocuMind team. We tested each product, measured where we win, and told you where we don't.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="font-mono-label text-muted-foreground mb-10">All comparisons · {COMPETITORS.length}</div>
        <div className="border-t border-l border-border">
          {COMPETITORS.map((c, i) => {
            const live = data?.competitors?.find((x) => x.slug === c.slug);
            return (
              <Link
                to={`/compare/${c.slug}`}
                key={c.slug}
                data-testid={`compare-link-${c.slug}`}
                className="grid grid-cols-12 border-r border-b border-border hover:bg-muted group"
              >
                <div className="col-span-1 p-8 font-serif-display text-3xl text-muted-foreground">{String(i + 1).padStart(2, '0')}</div>
                <div className="col-span-7 p-8">
                  <div className="font-serif-display text-3xl lg:text-4xl tracking-tight mb-2">DocuMind <span className="italic text-muted-foreground">vs</span> {c.name}</div>
                  {live && <div className="text-sm text-muted-foreground">{live.tagline}</div>}
                </div>
                <div className="col-span-3 p-8 flex items-center font-mono-label text-muted-foreground">
                  {live ? `From ${live.price_from}` : ""}
                </div>
                <div className="col-span-1 p-8 flex items-center justify-end">
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform text-primary" />
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-8">
        <PlanFinder />
      </section>

      <SiteFooter />
    </div>
  );
}
